import { jsx as _jsx } from "react/jsx-runtime";
import { Select } from '@robinpowered/ui-kit';
import { useTranslation } from 'react-i18next';
import { useEffect, useMemo } from 'react';
import { useGetLocationsForOrg } from '../../hooks/useLocationLevel/useGetLocationsForOrg';
export var LocationSelect = function (_a) {
    var currentOrgId = _a.currentOrgId, value = _a.value, onChange = _a.onChange, selectedLocationId = _a.selectedLocationId;
    var t = useTranslation('spaceBooking').t;
    var _b = useGetLocationsForOrg({
        currentOrgId: currentOrgId,
    }), locations = _b.locations, loading = _b.loading;
    var options = useMemo(function () {
        if (!locations)
            return;
        return locations === null || locations === void 0 ? void 0 : locations.filter(function (location) { return (location === null || location === void 0 ? void 0 : location.totalSpaces) > 0; }).map(function (location) { return ({
            label: location.name,
            value: location.id,
        }); });
    }, [locations]);
    useEffect(function () {
        var _a;
        if (!selectedLocationId && ((_a = options === null || options === void 0 ? void 0 : options[0]) === null || _a === void 0 ? void 0 : _a.value)) {
            onChange(options[0].value);
        }
    }, [selectedLocationId, options, onChange]);
    return (_jsx(Select, { loading: loading, value: value, options: options, filterOption: function (input, option) { var _a; return ((_a = option === null || option === void 0 ? void 0 : option.label) !== null && _a !== void 0 ? _a : '').toLowerCase().includes(input.toLowerCase()); }, onChange: onChange, placeholder: t('level_select.placeholder'), style: { width: '100%' }, showSearch: true }));
};
